import { Address, AddressFetchResponse } from '../settings/types/Address';

export const convertAddressData = (addresses: AddressFetchResponse): Address[] => {
  const addressesArray: Address[] = [];

  Object.entries(addresses).forEach(([type, address]) => {
    addressesArray.push({
      address: address.address,
      city: address.city,
      companyId: address.company_id,
      companyName: address.company_name,
      countryIso: address.country_iso,
      createdAt: address.created_at,
      email: address.email,
      firstName: address.first_name,
      lastName: address.last_name,
      number: address.number,
      phoneNumber: address.phone_number,
      taxId: address.tax_id,
      type: type,
      userId: address.user_id,
      vatId: address.vat_id,
      zip: address.zip,
    });
  });

  return addressesArray;
};
